import { Services } from '@sigma-frontend-libs/commons'

import { buttonModes } from '@/utils'

import button from '@/components/button'
import ContactsForm from '@/components/services/contacts/form'

function renderFields(h) {
  return h(
    ContactsForm,
    {
      props: {
        value: this.proxy,
        isFilter: true
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}

function renderClearButton(h) {
  return h(
    'div',
    {
      class: `${Services.contacts}-actions`
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('filter.clear'),
            mode: buttonModes.flat
          },
          on: {
            click: () => {
              this.clearFilter()
            }
          }
        }
      )
    ]
  )
}

export default function(h) {
  return h(
    'g-card',
    {
      class: `${Services.contacts}-filter`,
      props: {
        rounded: true,
        outline: true
      }
    },
    [

      renderFields.call(this, h),
      renderClearButton.call(this, h)
    ]
  )
}
